export default "__VITE_ASSET__$LnFoG0B__"